var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinibusinline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_354_1132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z",
    fill: "#FEE187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7035 6.3889L15.9066 6.96229L14.0555 5.11115L9.25422 11.0096L9.36967 11.125L4.74326 11.5L9.22588 15.9826L7.85702 17.0661V16.1981L5.75 17.25L6.57831 18.0783L6.09927 18.4575L10.6076 22.9658C10.9021 22.9884 11.1997 23 11.5 23C17.4699 23 22.3769 18.4509 22.9447 12.6301L16.7035 6.3889Z",
    fill: "#FFC61B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13091 18.6724H6.48223C6.23386 18.6724 6.03261 18.471 6.03261 18.2227V16.2773C6.03261 16.0289 6.23395 15.8276 6.48223 15.8276H8.13095C8.37933 15.8276 8.58058 16.029 8.58058 16.2773V18.2227C8.58053 18.4711 8.37928 18.6724 8.13091 18.6724Z",
    fill: "#272525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5177 18.6724H14.869C14.6206 18.6724 14.4194 18.471 14.4194 18.2227V16.2773C14.4194 16.0289 14.6207 15.8276 14.869 15.8276H16.5177C16.7661 15.8276 16.9674 16.029 16.9674 16.2773V18.2227C16.9674 18.4711 16.7661 18.6724 16.5177 18.6724Z",
    fill: "#272525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 17.25H5.75V7.76991C5.75 6.65437 6.65437 5.75 7.76991 5.75H15.2301C16.3456 5.75 17.25 6.65437 17.25 7.76991V17.25Z",
    fill: "#C92F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 7.76991C17.25 6.65437 16.3456 5.75 15.2301 5.75H11.4742V17.25H17.25V7.76991Z",
    fill: "#930000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 14.7418H7.84385C8.58295 14.7418 9.18221 14.1341 9.18221 13.3844V13.316H5.75V14.7418Z",
    fill: "#FFEDB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 14.7418H15.1562C14.4171 14.7418 13.8178 14.1341 13.8178 13.3844V13.316H17.25V14.7418Z",
    fill: "#FFC61B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 15.6524H5.75V17.2498H17.25V15.6524Z",
    fill: "#273B7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 15.6524H11.4744V17.2498H17.25V15.6524Z",
    fill: "#121149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6111 7.66669H6.38889V11.5H16.6111V7.66669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6111 7.66669H11.4744V11.5H16.6111V7.66669Z",
    fill: "#D0D1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0556 5.11115H8.94444V6.3889H14.0556V5.11115Z",
    fill: "#273B7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0556 5.11115H11.4744V6.3889H14.0556V5.11115Z",
    fill: "#121149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02101 8.94446H4.74326V11.5H6.02101V8.94446Z",
    fill: "#E09112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2567 8.94446H16.9789V11.5H18.2567V8.94446Z",
    fill: "#FF5419"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_354_1132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinibusinline);
export default __webpack_public_path__ + "static/media/minibus.inline.61a8bd8db6e8fbb53c34d6b8734dfd88.svg";
export { ForwardRef as ReactComponent };